import { Component, inject } from '@angular/core';
//import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { ReportStatus } from '@kildenshared/types/report/report-status.type';
import { MatToolbar } from '@angular/material/toolbar';
import { MatAnchor, MatButton } from '@angular/material/button';

@Component({
  selector: 'kilden3-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.css'],
  imports: [MatDialogTitle, MatToolbar, MatAnchor, MatButton, MatDialogClose],
})
export class ReportDialogComponent {
  data = inject(MAT_DIALOG_DATA);

  reports: ReportStatus | undefined;

  getCsv() {
    return this.data.reportData.csvDownloadUrl?.replace(/^http:\/\//i, 'https://');
  }
}
